import { useEffect } from 'react';
import { readUniversalLinkParams } from '../searchParams/searchParams';
import { useWebViewLink } from './useWebViewLink';

export function useAutoOpenWebView(cannedConnection?: boolean): void {
  const webViewLink = useWebViewLink(cannedConnection);

  const { app } = readUniversalLinkParams();

  useEffect(() => {
    if (app != 'webview' || !webViewLink) {
      return;
    }

    window.location.href = webViewLink;
  }, [app, webViewLink]);
}
